import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreCheckoutLoginService {

  display = new BehaviorSubject<DisplayLoginComponents>(new DisplayLoginComponents());
  constructor() { }

  public setDisplay(display: DisplayLoginComponents): void {
    this.display.next(display);
  }

  public getDisplay(): Observable<DisplayLoginComponents> {
    return this.display.asObservable();
  }
}

export class DisplayLoginComponents{
  constructor(enableCelular: boolean = true,
              enableSMS: boolean = false,
              enableInfo: boolean = false){

    this.enableCelular = enableCelular;
    this.enableSMS = enableSMS;
    this.enableInfo = enableInfo;
  }

  enableCelular: boolean;
  enableSMS: boolean;
  enableInfo: boolean;
}